import React from "react";
import {
  CardContainer,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter,
  CardDescription,
  CardValue
} from "./StatCard.styled";
import { withRouter } from "react-router-dom";

const StatCard = ({ title, value, description, redirectTo, history }) => {
  const redirect = () => {
    if (redirectTo.startsWith("http://") || redirectTo.startsWith("https://")) {
      window.location.href = redirectTo;
    } else {
      history.push(redirectTo);
    }
  };

  return (
    <CardContainer onClick={redirect}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <CardValue>{value}</CardValue>
      </CardContent>
      <div />
      <CardFooter>
        <CardDescription>{description}</CardDescription>
      </CardFooter>
    </CardContainer>
  );
};

export default withRouter(StatCard);
